export default {
  ROLE_SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_PREX_DEV: "ROLE_PREX_DEV",
  ROLE_PREX_SUPPORT: "ROLE_PREX_SUPPORT",
  ROLE_OWNER: "ROLE_OWNER",
  ROLE_MANAGER: "ROLE_MANAGER",
  ROLE_ACCOUNTANT: "ROLE_ACCOUNTANT",
  ROLE_STAFF: "ROLE_STAFF",
};

export type Role =
  | "ROLE_SUPER_ADMIN"
  | "ROLE_ADMIN"
  | "ROLE_PREX_DEV"
  | "ROLE_PREX_SUPPORT"
  | "ROLE_OWNER"
  | "ROLE_MANAGER"
  | "ROLE_ACCOUNTANT"
  | "ROLE_STAFF";
